export const LANDING = '/';
export const MESSAGE_LIST = '/messagelist'
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const SCORES = '/scores'
export const ARCHIVES = '/archives'